import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../shared/services/account.service';
import { User } from '../shared/types/User';
import { AppTranslationService } from '../app-translation.service';
import { VueServerMessage, VueServerMessageType } from '@vue/vueframework';
import { SessionDataService } from '../shared/services/session-data.service';
import { AccountRecoveryUtil } from '../shared/utils/accountrecovery.utils';
import { WebNGRedirectExtras } from '../shared/types/WebNGRedirectExtras';

@Component({
  selector: 'app-display-username',
  standalone: false,
  styleUrls: [ './display-username.component.css' ],
  templateUrl: './display-username.component.html'
})
export class DisplayUsernameComponent implements OnInit {
  public translations = {
    passwordResetText: '',
    returnToLogin: '',
    successfulRetrieval: '',
    title: '',
    usernameLabel: ''
  };
  public messages: VueServerMessage[] = [];
  public user: User;
  public redirectToWebNGFormEventEmitter = new EventEmitter();

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private appTranslationService: AppTranslationService,
    private sessionDataService: SessionDataService,
    private accountRecoveryUtil: AccountRecoveryUtil,
  ) {}

  public ngOnInit(): void {
    if (!this.route.snapshot.params.clientCode) {
      this.accountRecoveryUtil.navigateToNotFound();
    } else if (!this.sessionDataService.getUser() || !this.sessionDataService.getUser().userName) {
      this.accountRecoveryUtil.navigateToRetrieveUsername(this.route.snapshot.params.clientCode);
    } else {
      this.user = this.sessionDataService.getUser();
      this.getTranslations();
      this.messages.push(
        new VueServerMessage(VueServerMessageType.Success, this.translations.successfulRetrieval, true, '1')
      );
    }
  }

  public returnToLogin(): void {
    const extras = new WebNGRedirectExtras();
    extras.username = this.user.userName;
    this.redirectToWebNGFormEventEmitter.emit(extras);
  }

  public goToPasswordResetPage(): void {
    this.accountRecoveryUtil.navigateToRetrievePassword(this.route.snapshot.params.clientCode);
  }

  private getTranslations(): void {
    this.translations.title =
      this.appTranslationService.getTranslation('AccountRecovery', 'RetrieveUsernameComponent.PageTitle');
    this.translations.usernameLabel =
      this.appTranslationService.getTranslation('AccountRecovery', 'label.username');
    this.translations.successfulRetrieval =
      this.appTranslationService.getTranslation('AccountRecovery', 'DisplayUsernameComponent.successfulRetrieval');
    this.translations.passwordResetText =
      this.appTranslationService.getTranslation('AccountRecovery', 'DisplayUsernameComponent.passwordResetText');
    this.translations.returnToLogin =
      this.appTranslationService.getTranslation('AccountRecovery', 'button.ReturnToLogin');
  }
}
